import { trigger, state, animate, style, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  state('in', style({ opacity: 1 })),
  transition('void => *', [style({ opacity: 0 }), animate(400)]),
]);
